export const handleReCaptcha = async (executeRecaptcha) => {
  if (!executeRecaptcha) {
    console.log('Execute recaptcha not yet available');
    return handleReCaptcha();
  }

  const token = await executeRecaptcha('book_appointment');
  return token;
};
